
const state = () => ({
  oaid:""
})

// getters
const getters = {
  oaid:(state)=>{
        return state.oaid
    }
}

// actions
const actions = {

}

// mutations
const mutations = {
  oaid(state, {oaid}){
    state.oaid = oaid
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/entity.js